/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IMediaModel, LabelPlacement } from "@bms/common";
import React, { useMemo } from "react";

import "./MediaPriceLabel.scss";

type Props = {
  media?: IMediaModel;
  placement?: LabelPlacement;
};

export const MediaPriceLabel = ({ media, placement }: Props) => {
  const labelStyle = useMemo<React.CSSProperties>(() => {
    switch (placement) {
      case LabelPlacement.TopLeft:
        return {
          top: "0.25rem",
          left: "0.25rem",
        };
      case LabelPlacement.TopRight:
        return {
          top: "0.25rem",
          right: "0.25rem",
        };
      case LabelPlacement.BottomLeft:
        return {
          bottom: "0.5rem",
          left: "0.25rem",
        };
      case LabelPlacement.BottomRight:
        return {
          bottom: "0.5rem",
          right: "0.25rem",
        };
      case LabelPlacement.Metadata:
        return {
          position: "relative",
          backgroundColor: "var(--cell-background-color)",
        };
      default:
        return {
          display: "none",
        };
    }
  }, [placement]);

  if (!media?.Price?.Price || !placement || !media?.Price?.CurrencyCode) {
    return null;
  }

  return (
    <div className="MediaPriceLabel" style={labelStyle}>
      {media?.Price?.Price.toFixed(2)} {media?.Price?.CurrencyCode}
    </div>
  );
};
